import { HttpContext, HttpContextToken } from '@angular/common/http';

export enum GRECAPTCHA_ACTIONS {
  REGISTRATION_HOLD = 'registration_hold',
  REGISTRATION_EMAIL_VERIFICATION = 'registration_email_verification',
  REGISTRATION_SMS_VERIFICATION = 'registration_sms_verification',
  REGISTRATION_CONFIRM = 'registration_confirm',
  CONTACT = 'contact',
}

export const GRECAPTCHA_ACTION = new HttpContextToken<
  `${GRECAPTCHA_ACTIONS}` | null
>(() => null);

export const createNewGRecaptchaContext = (action: `${GRECAPTCHA_ACTIONS}`) => {
  return new HttpContext().set(GRECAPTCHA_ACTION, action);
};
